import ReactTooltip from 'react-tooltip'
import {
  memo,
  // , useState
} from 'react'
import classNames from 'classnames'
import StencilImageWithFallback from '../Common/StencilImageWithFallback'
import PrimaryCard from '@/components/Common/PrimaryCard'
import Info from '@/assets/common/info.inline.svg'
import USStockDetailDataType from '@/components/USStocks/USStocksChildPage/utils/USStockDetail-type'
import { BrandsData } from '@/components/Stocks/Widgets/types'
import { StrapiV4RichTextEditor } from '@/stories/strapi-4/widget-components/rich-text-editor/rich-text-editor'

const CompanyInformation = memo(
  ({
    data,
    desc = '',
    containerClass,
    brands_data,
    childClass = '',
    headingClassName = '',
  }: {
    data: USStockDetailDataType['stockDetail']['companyDataTemplate'] & {
      strapiAboutSection?: string | null
    }
    desc?: string
    containerClass?: string
    brands_data?: BrandsData[] | null
    childClass?: string
    headingClassName?: string
  }) => {
    const { description, title, dataList, info_web, strapiAboutSection } = data

    // const [expanded, setExpanded] = useState(false)
    return (
      <PrimaryCard
        containerClass={classNames(`mb-10`, {
          [containerClass ?? '']: containerClass,
        })}
        childClass={`p-4 md:p-6 ${childClass}`}
      >
        <div className="flex flex-col">
          <div className="flex w-full items-center justify-between">
            <h2 className={classNames('text-xl font-medium', headingClassName)}>
              {title}
            </h2>
            <div className="flex">
              <div
                className="flex w-full"
                data-tip={
                  info_web?.content_data[0]?.description
                    ? info_web.content_data[0]?.description
                    : desc
                }
                data-for="CompanyInformation"
                data-place="bottom"
              >
                {info_web && (
                  <>
                    <span className="h-4 w-4 cursor-pointer">
                      <Info />
                    </span>
                    <ReactTooltip
                      className="w-48 bg-black text-xs font-normal text-white"
                      id="CompanyInformation"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
          {strapiAboutSection ? (
            <StrapiV4RichTextEditor
              content={strapiAboutSection}
              className="text-sm"
            />
          ) : typeof description === 'string' ? (
            <div
              className="text-brand-grey-dark mt-4 text-sm font-normal leading-6"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          ) : (
            <div className="text-brand-grey-dark mt-4 text-sm font-normal leading-6">
              {description}
            </div>
          )}
          {!!brands_data?.length && (
            <div className="no-scrollbar mt-4 flex gap-2 overflow-auto">
              {brands_data.map((brand, idx) => (
                <div
                  key={idx}
                  title={`${brand.name} Share Price`}
                  className="rounded border p-2"
                >
                  {brand.logo && (
                    <div className="flex h-[50px] min-h-[50px] w-[50px] min-w-[50px] rounded-full ">
                      <StencilImageWithFallback
                        className="rounded-full object-cover "
                        icon={brand.logo}
                        altTag={`${brand.name} Share Price`}
                        height={50}
                        width={50}
                        initialAlphabet={brand.name?.[0]}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {!!dataList.length && (
            <table className="border-b-1 mt-8 flex flex-col">
              <tbody>
                {dataList
                  .filter(item => item.title && item.subtitle)
                  .map((item, index) => (
                    <tr
                      key={index}
                      className="border-t-1 flex items-center justify-between p-4 text-sm"
                    >
                      <td className="text-left">{item.title}</td>
                      <td className="text-right">{item.subtitle}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </PrimaryCard>
    )
  },
)

CompanyInformation.displayName = 'CompanyInformation'

export default CompanyInformation
